import { Categories } from 'src/types/User';
import { translateKey } from 'src/locales/translate';

/**
 * Maps specialization name ID to its Polish translation
 * @param specializationName - The specialization name ID (e.g., "veterinary_nutrition")
 * @returns The Polish translation of the specialization name
 */
export const mapCategoryNameToJobTitle = (categoryName: string): string => {
  const specializationTranslations: Record<string, string> = {
    [Categories.veterinarian]: 'Lekarz weterynarii',
    [Categories.dietitian]: translateKey("search.category.dietitian"),
    [Categories.behaviorist]: translateKey("search.category.behaviorist"),
    [Categories.physiotherapist]: translateKey("search.category.physiotherapist"),
  };

  return specializationTranslations[categoryName] || categoryName;
};
